import React, { useEffect, useState, memo } from "react";
import { Col, Card, Nav, Placeholder } from "react-bootstrap";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ReactApexChart from "react-apexcharts";
import getSpecificInventoryClicksDistribution from "../../../../services/micro/get_specific_inventory_clicks_distribution";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

function SpecificInventoryClickDistributionChart({
  currentPeriod,
  colors,
  inventoryId,
}) {
  const [response, setResponse] = useState();
  const [reset, setReset] = useState(0);

  useEffect(() => {
    if (currentPeriod?.[0] && currentPeriod?.[1]) {
      getSpecificInventoryClicksDistribution(inventoryId, currentPeriod).then((response) => {
        if (response?.data) {
            setResponse(response.data);
          }
        });
    }
  }, [currentPeriod]);

  if (!response) {
    return (
      <React.Fragment>
        <Col xl="7">
          <Placeholder
            as={Card.Title}
            animation="glow"
            style={{ color: "var(--bs-body-color)" }}
          >
            <Placeholder style={{ height: 400, width: "100%" }} />
          </Placeholder>
        </Col>
      </React.Fragment>
    );
  } else {
    const minCpc = Math.min(
      ...response.map((dataset) => Math.min(...dataset.map((item) => item.cpc)))
    );
    const maxCpc = Math.max(
      ...response.map((dataset) => Math.max(...dataset.map((item) => item.cpc)))
    );

    const optionMetrics = {
      chart: {
        parentHeightOffset: 0,
        type: "line",
        toolbar: { show: false },
        stacked: false,
        zoom: {
          enabled: false,
        },
      },
      colors: colors,
      grid: {
        borderColor: "rgba(72,94,144, 0.08)",
        yaxis: {
          lines: { show: false },
        },
        padding: { top: -20 },
      },
      stroke: {
        width: 2,
      },
      xaxis: {
        type: "datetime",
        tickAmount: 6,
        decimalsInFloat: 0,
        labels: {
          style: {
            colors: "#6e7985",
            fontSize: "11px",
          },
        },
      },
      yaxis: {
        min: minCpc - 1,
        max: maxCpc + 1,
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        y: {
          formatter: function (val) {
            return "$" + Number(val).toFixed(2);
          },
        },
        // custom: function({ series, seriesIndex, dataPointIndex, w }) {
        //   const date = w.globals.labels[dataPointIndex]; 
        //   let tooltipHtml = `<div style="padding: 8px 10px; max-width: 260px;">`;
        //   tooltipHtml += `<div style="font-weight: 600; font-size: 14px; margin-bottom: 8px;">Selected date: ${new Date(date || new Date()).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</div>`;

      
        //   w.config.series.forEach((s, i) => {
        //     const color = w.config.colors[i] || '#000';
        //     const name = s.name;
        //     const value = series[i][dataPointIndex];
      
        //     if (value !== undefined) {
        //       tooltipHtml += `
        //         <div style="display: flex; align-items: center; margin: 5px 0; padding: 5px 0;">
        //           <span style="display: inline-block; width: 10px; height: 10px; background-color: ${color}; margin-right: 6px; border-radius: 50%;"></span>
        //           <strong>${name}:</strong> <span style="margin-left: 5px;">$${Number(value).toFixed(2)}</span>
        //         </div>`;
        //     }
        //   });
      
        //   return `<div class="custom-tooltip">${tooltipHtml}</div>`;
        // }
      },
    };

    const lines = response
    .slice(0, 10) // this number (10) can be changed to any number in the future, ideally it should be max invetories items allowed to display
    .map((dataset, index) => ({
      data: dataset.map((item) => ({ x: new Date(item.date), y: item.cpc })),
      name: `Position ${index + 1}`,
    }));

    return (
      <Col xl="7">
        <Card className="card-one">
          <Card.Header>
            <Card.Title as="h6">CPC Development by Position</Card.Title>
            <Nav className="nav-icon nav-icon-sm ms-auto">
              <Nav.Link href="">
                <i
                  className="ri-refresh-line"
                  onClick={() => setReset(reset + 1)}
                ></i>
              </Nav.Link>
            </Nav>
          </Card.Header>
          <Card.Body className="p-3">
            <div className="ht-350">
              <ReactApexChart
                key={reset}
                series={lines}
                options={optionMetrics}
                type="line"
                height={365}
                className="apex-chart-two"
              />
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  }
}

export default memo(SpecificInventoryClickDistributionChart);